import { Cancel, MoreVert, Search, Tune } from "@material-ui/icons";
import moment from "moment";
import { default as React } from "react";
import {
  Button,
  Card,
  Carousel,
  Col,
  Dropdown,
  Form,
  InputGroup,
  Row,
  Modal,
} from "react-bootstrap";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ImageLoader from "react-load-image";
import { connect } from "react-redux";
import {
  deleteTransactionDataAction,
  getAllTransactionsAction,
} from "../../../actions/TransactionActions";
import { getVendorTransactionsAction } from "../../../actions/VendorTransactionActions";
import { getBuyerTransactionsAction } from "../../../actions/BuyerTransactionActions";
import { getSubscriptionCounterAction } from "../../../actions/SubscriptionReportAction";
import {
  getContactsActions,
  buyerAgentsAction,
} from "./../../../actions/UserActions";
import UrlConstants from "../../../config/UrlConstants";
import downIcon from "./../../../assets/img/down.png";
import noRecord from "./../../../assets/img/no-record.png";
import Logo from "./../../../assets/img/logo.png";
import placeholderImage from "./../../../assets/img/property-placeholder.jpg";
import loaderImage from "./../../../assets/img/Ring-Preloader.gif";
import upIcon from "./../../../assets/img/up.png";
import {
  cryptoTokenDecode,
  getContingencyAssignee,
  getContingencyData,
  getTimeFromMins,
  toastMessage,
} from "./../../Common/Common";
import DeletePrompt from "./../../Common/DeletePrompt";
import * as code from "./../../../config/Constants";
import * as constant from "./../../../config/Constants";
import * as message from "./../../../config/CommonMessages";
import TransactionPrompt from "../../Common/TransactionPrompt";
import { TextField, InputAdornment } from "@material-ui/core";

var _ = require("lodash");

function Preloader(props) {
  return <img src={loaderImage} />;
}

class TransactionList extends React.Component {
  constructor(props) {
    var userType = cryptoTokenDecode().usertype;
    let currentType = localStorage.getItem("currentRole");
    super(props);
    this.state = {
      transactions: [],
      originalTransactions: [],
      filteredTransactions: [],
      searchedTransactions: [],
      isFiltered: false,
      isSearched: false,
      showLoader: false,
      sortParams: { value: "modifiedDate", seq: "desc" },
      searchArtist: "",
      searchClient: "",
      searchDescription: "",
      searchShortname: "",
      userType: userType.toUpperCase(),
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      filterParam: "",
      delTransactionId: "",
      deleteTransactionPrompt: false,
      showHideFilter: false,
      showHideSearch: false,
      draftChecked: true,
      inProgressChecked: true,
      pauseChecked: true,
      completedChecked: false,
      canceledChecked: false,
      selectedFilterStatus: ["DRAFT", "INPROGRESS", "PAUSED"],
      showTransactionPrompt: false,
      clients: [],
      contacts: [],
      acctowners: [],
      acctownerId: "",
      page: 0,
      recordPerPage: constant.RECORD_PER_PAGE,
    };
    this.deleteTransaction = this.deleteTransaction.bind(this);
  }

  getAcctowners(pageIndex) {
    let rolename = "admin";
    let myId = localStorage.getItem("ID");
    this.props
      .buyerAgentsAction(this.state.recordPerPage, pageIndex)
      .then((aoRes) => {
        for (let a = 0; a < this.props.buyerAgents.length; a++) {
          rolename = "ep";
          this.props
            .getContactsActions(
              rolename,
              "?id=" + this.props.buyerAgents[a]._id + "&rolename=" + rolename
            )
            .then((res) => {
              for (let c = 0; c < this.props.contacts.length; c++) {
                if (this.props.contacts[c]._id === myId) {
                  let acctowners = this.props.buyerAgents[a];
                  localStorage.setItem("ownerId", acctowners._id);
                  localStorage.setItem(
                    "companyName",
                    acctowners.companyInformation.name
                  );
                }
              }
            });
        }
      });
  }

  componentWillMount() {
    this.setState({
      showLoader: true,
    });
    // if (this.state.userType === message.VENDOR && this.state.currentRole === message.BUYERAGENT) {
    //     console.log('calling getAcctowners');
    //     this.getAcctowners(this.state.page);
    // }

    //transation list from redirection history object
    if (this.props.history.location.transactions != undefined) {
      this.setState(
        {
          transactions: this.props.history.location.transactions || [],
          originalTransactions: this.props.history.location.transactions || [],
          filteredTransactions: this.props.history.location.transactions || [],
        },
        () => {
          this.sortTransactions("modifiedDate", "desc");
          this.setState({
            showLoader: false,
          });
          this.changeTransactionsFilter();
        }
      );
    } else {
      //Load transcation by user type
      if (
        this.state.userType !== null &&
        this.state.userType === message.BUYER &&
        this.state.currentRole === message.BUYER
      ) {
        this.props.getAllTransactionsAction().then((res) => {
          this.props.getBuyerTransactionsAction().then((buyerRes) => {
            let transactionRes = this.props.buyerTransactions.data;
            this.setState(
              {
                transactions: this.props.transactions.data.concat(
                  transactionRes
                ),
                originalTransactions: this.props.transactions.data.concat(
                  transactionRes
                ),
                filteredTransactions: this.props.transactions.data.concat(
                  transactionRes
                ),
              },
              () => {
                this.sortTransactions("modifiedDate", "desc");
                this.setState({
                  showLoader: false,
                });
                this.changeTransactionsFilter();
              }
            );
          });
        });
      } else if (
        this.state.userType !== null &&
        this.state.userType === message.VENDOR
      ) {
        this.props.getAllTransactionsAction().then((res) => {
          this.props.getVendorTransactionsAction().then((vendorRes) => {
            let transactionRes = this.props.vendorTransactions.data;
            this.setState(
              {
                transactions: this.props.transactions.data.concat(
                  transactionRes
                ),
                originalTransactions: this.props.transactions.data.concat(
                  transactionRes
                ),
                filteredTransactions: this.props.transactions.data.concat(
                  transactionRes
                ),
              },
              () => {
                this.sortTransactions("modifiedDate", "desc");
                this.setState({
                  showLoader: false,
                });
                this.changeTransactionsFilter();
              }
            );
          });
        });
        this.getAcctowners(this.state.page);
      } else if (
        this.state.userType !== null &&
        this.state.userType != message.BUYER &&
        this.state.userType != message.VENDOR
      ) {
        if (this.state.userType === message.ADMIN) {
          //Get transactions from localstorage
          let transactions = JSON.parse(
            localStorage.getItem("transactions") || []
          );
          this.setState(
            {
              transactions,
              originalTransactions: transactions,
              filteredTransactions: transactions,
            },
            () => {
              this.sortTransactions("modifiedDate", "desc");
              this.setState({
                showLoader: false,
              });
              this.changeTransactionsFilter();
            }
          );
        } else {
          // Get all transactions
          this.props.getAllTransactionsAction().then((res) => {
            let transactionRes = this.props.transactions.data;
            // console.log(transactionRes);
            this.setState(
              {
                transactions: this.props.transactions.data || [],
                originalTransactions: this.props.transactions.data || [],
                filteredTransactions: this.props.transactions.data || [],
              },
              () => {
                this.sortTransactions("modifiedDate", "desc");
                this.setState({
                  showLoader: false,
                });
                this.changeTransactionsFilter();
              }
            );
            if (this.props.location.state) {
              //Filter transactions if its from dashboard transactions count widget
              let status = this.props.location.state.type;
              this.setState({ selectedFilterStatus: [status] });
              if (status === "DRAFT") {
                this.setState({
                  inProgressChecked: false,
                  pauseChecked: false,
                });
              } else if (status === "INPROGRESS") {
                this.setState({ draftChecked: false, pauseChecked: false });
              } else if (status === "PAUSED") {
                this.setState({
                  draftChecked: false,
                  inProgressChecked: false,
                });
              } else if (status === "COMPLETED") {
                this.setState({
                  draftChecked: false,
                  pauseChecked: false,
                  inProgressChecked: false,
                  completedChecked: true,
                });
              } else if (status === "CANCELED") {
                this.setState({
                  draftChecked: false,
                  pauseChecked: false,
                  inProgressChecked: false,
                  canceledChecked: true,
                });
              }
              this.changeTransactionsFilter();
            }
          });
        }
      }
    }

    if (this.state.userType !== null && this.state.userType === message.BUYER) {
      this.getTransactions();
    }

    this.getAllContacts();
  }

  searchByArtist(e) {
    let query = e.target.value;
    let transactions = this.state.transactions;

    if (query !== "") {
      let results = transactions.filter((transaction) => {
        return (
          transaction.listingAgents[0].firstname
            .toLowerCase()
            .includes(query.toLowerCase()) ||
          transaction.listingAgents[0].lastname
            .toLowerCase()
            .includes(query.toLowerCase())
        );
      });

      this.setState({
        transactions: results,
      });
    } else {
      this.getTransactions();
    }

    this.setState({
      searchArtist: query,
    });
  }

  searchByClient(e) {
    let query = e.target.value;
    let transactions = this.state.transactions;

    if (query !== "") {
      let results = transactions.filter((transaction) => {
        return (
          transaction.buyer[0].firstname
            .toLowerCase()
            .includes(query.toLowerCase()) ||
          transaction.buyer[0].lastname
            .toLowerCase()
            .includes(query.toLowerCase())
        );
      });

      this.setState({
        transactions: results,
      });
    } else {
      this.getTransactions();
    }

    this.setState({
      searchClient: query,
    });
  }

  searchByDescription(e) {
    let query = e.target.value;
    let transactions = this.state.transactions;

    if (query !== "") {
      let results = transactions.filter((transaction) => {
        return transaction.heldBy.toLowerCase().includes(query.toLowerCase());
      });

      this.setState({
        transactions: results,
      });
    } else {
      this.getTransactions();
    }

    this.setState({
      searchDescription: query,
    });
  }

  searchByShortname(e) {
    let query = e.target.value;
    let transactions = this.state.transactions;

    if (query !== "") {
      let results = transactions.filter((transaction) => {
        return transaction.shortName
          .toLowerCase()
          .includes(query.toLowerCase());
      });

      this.setState({
        transactions: results,
      });
    } else {
      this.getTransactions();
    }

    this.setState({
      searchShortname: query,
    });
  }

  filterByStatus(e) {
    let index;
    let options = this.state.selectedFilterStatus;
    if (e.target.checked) {
      options.push(e.target.value);
    } else {
      index = options.indexOf(e.target.value);
      options.splice(index, 1);
    }
    this.setState({ selectedFilterStatus: options }, () => {
      this.changeTransactionsFilter();
    });
  }
  /**
   * @desc transaction filter based on status
   */
  changeTransactionsFilter() {
    let param = this.state.selectedFilterStatus;
    var transactions = this.state.originalTransactions;
    if (this.state.isSearched) {
      transactions = this.state.searchedTransactions;
    }
    transactions = transactions.filter((transaction) => {
      const typeMatch =
        param.length > 0
          ? param.filter((e) => {
              return (transaction.status + "").toUpperCase() == e.toUpperCase();
            }).length > 0
          : false;
      return typeMatch;
    });
    this.setState({
      transactions,
      filteredTransactions: transactions,
      isFiltered: false,
      filterParam: param,
    });
  }

  /**
   * @desc sort transactions by given sequence asc/desc
   * @param {*} param
   * @param {*} sequence
   */
  sortTransactions(param, sequence) {
    var sortParams = { value: param, seq: sequence };
    var transactions = this.state.transactions;
    if (sequence == undefined || sequence == "" || sequence == "asc") {
      transactions = _.sortBy(transactions, param);
    } else {
      transactions = _.sortBy(transactions, param).reverse();
    }
    this.setState({
      transactions,
      filteredTransactions: transactions,
      sortParams,
    });
  }

  clearFilter() {
    this.setState(
      {
        transactions: this.state.originalTransactions,
        filteredTransactions: this.state.originalTransactions,
        isFiltered: false,
        isSearched: false,
        searchParam: "",
        filterParam: "",
        draftChecked: true,
        inProgressChecked: true,
        pauseChecked: true,
        completedChecked: false,
        canceledChecked: false,
        selectedFilterStatus: ["DRAFT", "INPROGRESS", "PAUSED"],
      },
      () => {
        this.sortTransactions("modifiedDate", "desc");
        this.changeTransactionsFilter();
      }
    );
  }

  /**
   * @desc get all transaction list and set to state
   */
  getTransactions() {
    if (this.state.userType !== null && this.state.userType === message.BUYER) {
      this.props.getBuyerTransactionsAction().then((res) => {
        this.setState(
          {
            transactions: this.props.buyerTransactions.data || [],
            originalTransactions: this.props.buyerTransactions.data || [],
            filteredTransactions: this.props.buyerTransactions.data || [],
          },
          () => {
            this.sortTransactions("modifiedDate", "desc");
            this.setState({
              showLoader: false,
            });
            this.changeTransactionsFilter();
          }
        );
      });
    } else if (
      this.state.userType !== null &&
      this.state.userType === message.VENDOR
    ) {
      this.props.getVendorTransactionsAction().then((res) => {
        this.setState(
          {
            transactions: this.props.vendorTransactions.data || [],
            originalTransactions: this.props.vendorTransactions.data || [],
            filteredTransactions: this.props.vendorTransactions.data || [],
          },
          () => {
            this.sortTransactions("modifiedDate", "desc");
            this.setState({
              showLoader: false,
            });
            this.changeTransactionsFilter();
          }
        );
      });
    } else {
      this.props.getAllTransactionsAction().then((res) => {
        this.setState(
          {
            transactions: this.props.transactions.data || [],
            originalTransactions: this.props.transactions.data || [],
            filteredTransactions: this.props.transactions.data || [],
          },
          () => {
            this.sortTransactions("modifiedDate", "desc");
            this.changeTransactionsFilter();
          }
        );
      });
    }
  }

  confirmDeleteTransaction(id) {
    this.setState({ deleteTransactionPrompt: true, delTransactionId: id });
  }

  handleTransactionPrompt() {
    this.setState({ showTransactionPrompt: true });
  }

  deleteTransaction(id) {
    this.props.deleteTransactionDataAction(id).then((res) => {
      this.getTransactions();
      this.setState({ deleteTransactionPrompt: false, delTransactionId: "" });
      // if ((this.state.userType === message.ACCTOWNER)
      //     && localStorage.getItem(code.IS_STRIPE_ENABLED) === "true") {
      //     this.props.getSubscriptionCounterAction().then(counterRes => {
      //         localStorage.setItem("transactionCount", counterRes[0].transactionLimitCounter);
      //     });
      // }
      // if ((this.state.userType === message.VENDOR && this.state.currentRole === message.BUYERAGENT)
      //     && localStorage.getItem(code.IS_STRIPE_ENABLED) === "true") {
      //     this.props.getSubscriptionCounterAction().then(counterRes => {
      //         localStorage.setItem("transactionCount", counterRes[0].transactionLimitCounter);
      //     });
      // }
    });
  }

  /**
   * @desc Progress bar data by transaction - task, status
   * Calculate schedule, overdue and completed task count and get % of it based on input param status
   */
  getProgressBar(tasks, status, tranSts) {
    if (tasks !== undefined && tasks !== null && tasks.length > 0) {
      let totalCnt = tasks.length;
      let schCnt = 0;
      let overdurCnt = 0;
      let completedCnt = 0;

      tasks.forEach((e) => {
        e.eventEndDate = new Date(
          moment(e.eventEndDate).format("MM/DD/YYYY ") + getTimeFromMins(e.time)
        );
        if (e.status == "SCHEDULED") {
          if (tranSts === "INPROGRESS") {
            schCnt = schCnt + 1;
            if (moment(e.eventEndDate) < moment()) {
              overdurCnt = overdurCnt + 1;
            }
          }
        } else if (e.status == "COMPLETED") {
          completedCnt = completedCnt + 1;
        }
      });

      let completed = 0;
      let overdue = 0;
      //get percentag of tasks based on given status
      if (status == "completed") {
        completed = (completedCnt * 100) / totalCnt;
        return completed.toFixed(0);
      } else if (status == "overdue") {
        overdue = (overdurCnt * 100) / totalCnt;
        return overdue.toFixed(0);
      } else {
        return totalCnt;
      }
    } else {
      return 0;
    }
  }

  setStatusFilter() {
    this.setState({ showHideFilter: !this.state.showHideFilter });
  }

  setSearchFilter() {
    this.setState({ showHideSearch: !this.state.showHideSearch });
  }

  getAllContacts() {
    this.props.getContactsActions().then((res) => {
      this.setState({
        contacts: this.props.contacts || [],
      });
    });
  }

  render() {
    return (
      <>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center trans-listing-head">
              <Col>
                <h4 className="title-med mt-0 pt-1">Artworks</h4>
              </Col>

              <Col className="col-auto" align="right">
                <Form inline className="justify-content-end">
                  <Row className="trans-listing-head-row">
                    <Col className="col-auto px-0 d-flex trans-listing-head-dropdown">
                      {/* <Form.Group controlId="" className='mb-0 mr-3'>
                                                <InputGroup className='icon-wrapper'>
                                                    <Form.Control type="text" className="form-control-head" placeholder="Artist" value={this.state.searchArtist} onChange={(e) => { this.searchByArtist(e) }} />
                                                    <span className='form-control-icn'>
                                                        <Search />
                                                    </span>
                                                </InputGroup>
                                            </Form.Group>
                                            <Form.Group controlId="" className='mb-0 mr-3'>
                                                <InputGroup className='icon-wrapper'>
                                                    <Form.Control type="text" className="form-control-head" placeholder="Client" value={this.state.searchClient} onChange={(e) => { this.searchByClient(e) }} />
                                                    <span className='form-control-icn'>
                                                        <Search />
                                                    </span>
                                                </InputGroup>
                                            </Form.Group>
                                            <Form.Group controlId="" className='mb-0 mr-3'>
                                                <InputGroup className='icon-wrapper'>
                                                    <Form.Control type="text" className="form-control-head" placeholder="Artwork" value={this.state.searchDescription} onChange={(e) => { this.searchByDescription(e) }} />
                                                    <span className='form-control-icn'>
                                                        <Search />
                                                    </span>
                                                </InputGroup>
                                            </Form.Group>
                                            <Form.Group controlId="" className='mb-0 mr-3'>
                                                <InputGroup className='icon-wrapper'>
                                                    <Form.Control type="text" className="form-control-head" placeholder="Artwork ID" value={this.state.searchShortname} onChange={(e) => { this.searchByShortname(e) }} />
                                                    <span className='form-control-icn'>
                                                        <Search />
                                                    </span>
                                                </InputGroup>
                                            </Form.Group> */}
                      <Form.Group controlId="" className="mb-0 mr-2">
                        <div className="c-select">
                          <select
                            className="form-control form-control-sm form-control-head"
                            style={{ width: "175px" }}
                            value={this.state.sortParams.value}
                            onChange={(e) => {
                              this.sortTransactions(
                                e.target.value,
                                e.target.value == "modifiedDate"
                                  ? "desc"
                                  : "asc"
                              );
                            }}
                          >
                            <option value="modifiedDate">
                              Sort: Last Updated
                            </option>
                            <option value="createdDate">
                              Sort: Date Created
                            </option>
                          </select>
                        </div>
                      </Form.Group>
                    </Col>

                    <Col className="col-auto pl-0 d-flex trans-listing-head-button">
                      <div className="multi-permit">
                        <Button
                          variant="primary"
                          className="btn-blue btn-head"
                          onClick={() => {
                            this.setStatusFilter();
                          }}
                          style={{
                            backgroundColor: "black",
                            border: "none",
                            marginTop: "1px",
                          }}
                        >
                          <Tune style={{ color: "white" }} />
                        </Button>
                        {this.state.showHideFilter && (
                          <ul style={{ listStyleType: "none", width: "200px" }}>
                            <li>
                              <input
                                type="checkbox"
                                value="INPROGRESS"
                                checked={this.state.inProgressChecked}
                                onChange={(e) => {
                                  this.setState({
                                    inProgressChecked: !this.state
                                      .inProgressChecked,
                                  });
                                  this.filterByStatus(e);
                                }}
                              />
                              In Progress
                            </li>
                            <li>
                              <input
                                type="checkbox"
                                value="COMPLETED"
                                checked={this.state.completedChecked}
                                onChange={(e) => {
                                  this.setState({
                                    completedChecked: !this.state
                                      .completedChecked,
                                  });
                                  this.filterByStatus(e);
                                }}
                              />
                              Completed
                            </li>
                            <li>
                              <input
                                type="checkbox"
                                value="CANCELED"
                                checked={this.state.canceledChecked}
                                onChange={(e) => {
                                  this.setState({
                                    canceledChecked: !this.state
                                      .canceledChecked,
                                  });
                                  this.filterByStatus(e);
                                }}
                              />
                              Canceled
                            </li>
                          </ul>
                        )}
                      </div>

                      <div className="multi-permit">
                        <Button
                          variant="primary"
                          className="btn-blue btn-head"
                          onClick={() => {
                            this.setSearchFilter();
                          }}
                          style={{
                            backgroundColor: "black",
                            border: "none",
                            marginTop: "1px",
                          }}
                        >
                          <Search style={{ color: "white" }} />
                        </Button>
                        {this.state.showHideSearch && (
                          <ul style={{ listStyleType: "none", width: "200px" }}>
                            <li>
                              <TextField
                                type="text"
                                label="Artist"
                                value={this.state.searchArtist}
                                onChange={(e) => this.searchByArtist(e)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Search />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </li>
                            <li>
                              <TextField
                                type="text"
                                label="Client"
                                value={this.state.searchClient}
                                onChange={(e) => this.searchByClient(e)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Search />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </li>
                            <li>
                              <TextField
                                type="text"
                                label="Artwork"
                                value={this.state.searchDescription}
                                onChange={(e) => this.searchByDescription(e)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Search />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </li>
                            <li>
                              <TextField
                                type="text"
                                label="Artwork ID"
                                value={this.state.searchShortname}
                                onChange={(e) => this.searchByShortname(e)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Search />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </li>
                          </ul>
                        )}
                      </div>

                      {this.state.userType !== message.BUYER &&
                      this.state.userType !== message.ADMIN ? (
                        <Form.Group controlId="" className="mb-0">
                          <Button
                            variant="primary"
                            className="btn-blue btn-head"
                            onClick={() => {
                              // NEED TO LOOK AT THIS AGAIN LATER
                              //   if (
                              //     localStorage.getItem(code.IS_STRIPE_ENABLED) ===
                              //     "true"
                              //   ) {
                              //     // if (Number(localStorage.getItem("transactionCount")) >= Number(localStorage.getItem("transactionLimit"))) {
                              //     //     toastMessage(code.ERROR, "You have reached your maximum limit of transactions")
                              //     // }
                              //     if (
                              //       localStorage.getItem("isActive") === "false"
                              //     ) {
                              //       toastMessage(
                              //         code.ERROR,
                              //         message.SUBSCRIPTION_NOT_ACTIVE
                              //       );
                              //     } else {
                              //       // this.props.history.push("/transactions/create")
                              //       this.handleTransactionPrompt();
                              //     }
                              //   } else {
                              //     // this.props.history.push("/transactions/create")
                              //     this.handleTransactionPrompt();
                              //   }

                              this.handleTransactionPrompt();
                            }}
                          >
                            Create Artwork
                          </Button>
                        </Form.Group>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
            <section className="transaction-list">
              <div className="container-custom">
                <Row className="align-items-center">
                  <Col className="text-right">
                    {this.state.sortParams.seq == "desc" && (
                      <Button
                        className="btn-sort w-icn"
                        variant="transparent"
                        onClick={() => {
                          this.sortTransactions(
                            this.state.sortParams.value,
                            "asc"
                          );
                        }}
                      >
                        <img src={downIcon} alt="sort" />
                      </Button>
                    )}
                    {(this.state.sortParams.seq == undefined ||
                      this.state.sortParams.seq == "asc" ||
                      this.state.sortParams.seq == "") && (
                      <Button
                        className="btn-sort w-icn"
                        variant="transparent"
                        onClick={() => {
                          this.sortTransactions(
                            this.state.sortParams.value,
                            "desc"
                          );
                        }}
                      >
                        <img src={upIcon} alt="sort" />
                      </Button>
                    )}
                    {(this.state.isFiltered || this.state.isSearched) && (
                      <Button
                        className="btn-sort wt-icn"
                        variant="transparent"
                        onClick={() => {
                          this.clearFilter();
                        }}
                      >
                        <Cancel />
                        <span>Clear</span>
                      </Button>
                    )}
                  </Col>
                </Row>
                <Row>
                  {/* Transactions rendered in list */}
                  {this.state.transactions.map((tran) => {
                    return (
                      <Col xs="12" sm="3">
                        <Card className="transaction-single">
                          <Card.Header
                            className="p-0"
                            style={{ position: "relative" }}
                          >
                            <Carousel
                              className="slide-transaction"
                              interval={false}
                              indicators={false}
                              fade={true}
                              controls={
                                tran.property.image.length <= 1 ? false : true
                              }
                            >
                              {tran.property.image.map((img, i) => {
                                return (
                                  <Carousel.Item
                                    key={i}
                                    onClick={() => {
                                      // localStorage.setItem("currentRole", tran.CurrentRole);

                                      !tran.draft
                                        ? this.props.history.push({
                                            pathname:
                                              "/artwork/detail/" + tran._id,
                                            currentRole: tran.CurrentRole,
                                          })
                                        : this.props.history.push({
                                            pathname:
                                              "/artwork/schedule/" + tran._id,
                                            currentRole: tran.CurrentRole,
                                          });
                                    }}
                                  >
                                    {img == null || img == "" ? (
                                      <img
                                        className="d-block w-100"
                                        src={placeholderImage}
                                      />
                                    ) : (
                                      <ImageLoader
                                        src={
                                          UrlConstants.AdminCreateTransactionUrl +
                                          "/upload?id=" +
                                          tran.ownerId +
                                          "&img=" +
                                          img
                                        }
                                      >
                                        <img />
                                        <img src={placeholderImage} />
                                        <Preloader />
                                      </ImageLoader>
                                    )}
                                  </Carousel.Item>
                                );
                              })}
                              {tran.property.image.length <= 0 && (
                                <Carousel.Item
                                  onClick={() => {
                                    // localStorage.setItem("currentRole", tran.CurrentRole);

                                    !tran.draft
                                      ? this.props.history.push({
                                          pathname:
                                            "/artwork/detail/" + tran._id,
                                          currentRole: tran.CurrentRole,
                                        })
                                      : this.props.history.push({
                                          pathname:
                                            "/artwork/schedule/" + tran._id,
                                          currentRole: tran.CurrentRole,
                                        });
                                  }}
                                >
                                  <img
                                    className="d-block w-100"
                                    src={placeholderImage}
                                  />
                                </Carousel.Item>
                              )}
                            </Carousel>
                          </Card.Header>
                          <Card.Body className="p-2">
                            <div
                              onClick={() => {
                                // localStorage.setItem("currentRole", tran.CurrentRole);

                                !tran.draft
                                  ? this.props.history.push({
                                      pathname: "/artwork/detail/" + tran._id,
                                      currentRole: tran.CurrentRole,
                                    })
                                  : this.props.history.push({
                                      pathname: "/artwork/schedule/" + tran._id,
                                      currentRole: tran.CurrentRole,
                                    });
                              }}
                            >
                              <Row>
                                <Col>
                                  <Card.Title className="mb-0 font-16 font-500">
                                    {getContingencyAssignee(
                                      this.state.contacts,
                                      tran.contingencies,
                                      "Client",
                                      "fullname"
                                    )}
                                  </Card.Title>
                                  <Card.Text className="mb-2 font-14 font-400">
                                    {(tran.transactionType
                                      ? tran.transactionType
                                      : "") +
                                      " - " +
                                      (tran.heldBy ? tran.heldBy : "")}
                                  </Card.Text>
                                  {/* <Card.Text className="mb-2 font-14 font-400">{(tran.heldBy ? tran.heldBy : "")}</Card.Text> */}
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  {this.state.userType === message.ACCTOWNER ? (
                                    <div style={{ lineHeight: "1.1em" }}>
                                      <span className="color-grey-2 font-12 font-500">
                                        Artist:{" "}
                                      </span>
                                      <span className="color-light-blue-1 font-12 font-600">
                                        {getContingencyAssignee(
                                          this.state.contacts,
                                          tran.contingencies,
                                          "Artist",
                                          "fullname"
                                        )}
                                      </span>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  {/* <div style={{ lineHeight: "1.1em" }}>
                                                                    <span className="color-grey-2 font-12 font-500">Artist: </span>
                                                                    <span className="color-light-blue-1 font-12 font-600">{getContingencyAssignee(this.state.contacts, tran.contingencies, "Artist")}</span>
                                                                </div> */}
                                  <div style={{ lineHeight: "1.1em" }}>
                                    <span className="color-grey-2 font-12 font-500">
                                      Artwork ID:{" "}
                                    </span>
                                    <span className="color-light-blue-1 font-12 font-600">
                                      {tran.shortName}
                                    </span>
                                  </div>
                                  <div style={{ lineHeight: "1.1em" }}>
                                    <span className="color-grey-2 font-12 font-500">
                                      Status:{" "}
                                    </span>
                                    <span className="color-light-blue-1 font-12 font-600">
                                      {tran.status}
                                    </span>
                                  </div>
                                  <div style={{ lineHeight: "1.1em" }}>
                                    <span className="color-grey-2 font-12 font-500">
                                      Updated on:{" "}
                                    </span>
                                    <span className="color-grey-1 font-12 font-500">
                                      {moment(tran.modifiedDate).format(
                                        "MM/DD/YYYY, hh:mm a"
                                      )}
                                    </span>
                                  </div>
                                  {/* {(this.state.userType === message.VENDOR && this.state.currentRole === message.BUYERAGENT) ? 
                                                                <div style={{ lineHeight: "1.1em" }}>
                                                                    <span className="color-grey-2 font-12 font-500">User Role: </span>
                                                                    <span className="color-grey-1 font-12 font-500">Artist</span>
                                                                </div> : ""} */}
                                  {/* {(tran.CurrentRole === message.ACCTOWNER && getContingencyData(tran.contingencies, "First Appointment", "assignee") === contactId) ? 
                                                                <div style={{ lineHeight: "1.1em" }}>
                                                                    <span className="color-grey-2 font-12 font-500">User Role: </span>
                                                                    <span className="color-grey-1 font-12 font-500">Artist</span>
                                                                </div> : ""}
                                                                {(tran.CurrentRole === message.ACCTOWNER && getContingencyData(tran.contingencies, "Paperwork", "assignee") === contactId) ? 
                                                                <div style={{ lineHeight: "1.1em" }}>
                                                                    <span className="color-grey-2 font-12 font-500">User Role: </span>
                                                                    <span className="color-grey-1 font-12 font-500">Client</span>
                                                                </div> : ""} */}
                                  {/* {(this.state.userType === message.BUYER) && tran.CurrentRole === message.BUYER ? 
                                                                <div style={{ lineHeight: "1.1em" }}>
                                                                    <span className="color-grey-2 font-12 font-500">User Role: </span>
                                                                    <span className="color-grey-1 font-12 font-500">Client</span>
                                                                </div> : ""} */}
                                </Col>
                              </Row>
                            </div>

                            {tran.CurrentRole === message.VENDOR ||
                            tran.CurrentRole === message.BUYER ? (
                              ""
                            ) : (
                              <Dropdown alignRight className="dropdown-action">
                                <Dropdown.Toggle
                                  variant="transparent"
                                  id="dropdown-folder1"
                                  className="p-0"
                                >
                                  <MoreVert />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    onClick={() => {
                                      localStorage.setItem(
                                        "currentRole",
                                        tran.CurrentRole
                                      );
                                      !tran.draft
                                        ? this.props.history.push(
                                            "/artwork/detail/" + tran._id
                                          )
                                        : this.props.history.push(
                                            "/artwork/schedule/" + tran._id
                                          );
                                    }}
                                  >
                                    Edit
                                  </Dropdown.Item>
                                  {tran.status !== "COMPLETED" && (
                                    <Dropdown.Item
                                      onClick={() => {
                                        // if (
                                        //   localStorage.getItem("isActive") ===
                                        //   "false"
                                        // ) {
                                        //   toastMessage(
                                        //     code.ERROR,
                                        //     message.SUBSCRIPTION_NOT_ACTIVE
                                        //   );
                                        // } else {
                                        //   this.confirmDeleteTransaction(
                                        //     tran._id
                                        //   );
                                        // }
                                        this.confirmDeleteTransaction(tran._id);
                                      }}
                                    >
                                      Delete
                                    </Dropdown.Item>
                                  )}
                                </Dropdown.Menu>
                              </Dropdown>
                            )}
                          </Card.Body>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </section>

            {this.state.transactions.length <= 0 && (
              <>
                {this.state.userType === message.VENDOR ||
                this.state.userType === message.BUYER ? (
                  <div className="no-transaction no-record">
                    <div className="no-transaction-inner">
                      <img src={noRecord} alt="no record" />
                      <p>No artworks found</p>
                    </div>
                  </div>
                ) : this.state.isFiltered || this.state.isSearched ? (
                  <div className="no-transaction no-record">
                    <div className="no-transaction-inner">
                      <img src={noRecord} alt="no record" />
                      <p>No artworks found</p>
                    </div>
                  </div>
                ) : (
                  <div className="no-transaction">
                    <div className="no-transaction-inner">
                      <img
                        src={Logo}
                        className="no-transaction-content"
                        alt=""
                      />
                      <h2 className="no-transaction-content">
                        No artworks found
                      </h2>
                      <hr />
                      {this.state.userType !== message.VENDOR &&
                      this.state.userType !== message.BUYER &&
                      this.state.userType !== message.ADMIN ? (
                        <Button
                          className="text-uppercase btn-orange btn-orange-lg"
                          onClick={() => {
                            // if (
                            //   localStorage.getItem(code.IS_STRIPE_ENABLED) ===
                            //   "true"
                            // ) {
                            //   if (
                            //     Number(
                            //       localStorage.getItem("transactionCount")
                            //     ) >=
                            //     Number(localStorage.getItem("transactionLimit"))
                            //   ) {
                            //     toastMessage(
                            //       code.ERROR,
                            //       "You have reached your maximum limit of artworks"
                            //     );
                            //   } else if (
                            //     localStorage.getItem("isActive") === "false"
                            //   ) {
                            //     toastMessage(
                            //       code.ERROR,
                            //       message.SUBSCRIPTION_NOT_ACTIVE
                            //     );
                            //   } else {
                            //     // this.props.history.push("/transactions/create")
                            //     this.handleTransactionPrompt();
                            //   }
                            // } else {
                            //   // this.props.history.push("/transactions/create")
                            //   this.handleTransactionPrompt();
                            // }

                            this.handleTransactionPrompt();
                          }}
                        >
                          Create Artwork
                        </Button>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                )}
              </>
            )}

            {/* Delete Transaction Modal */}
            <DeletePrompt
              deletePrompt={this.state.deleteTransactionPrompt}
              itemId={this.state.delTransactionId}
              cancel={() => {
                this.setState({ deleteTransactionPrompt: false });
              }}
              deleteConfirm={this.deleteTransaction}
            />

            {/* Transaction Choice Modal */}
            <TransactionPrompt
              showTransactionPrompt={this.state.showTransactionPrompt}
              cancel={() => {
                this.setState({ showTransactionPrompt: false });
              }}
            />
          </div>
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    transactions: state.reducer.transactions,
    isDTransDeleted: state.reducer.isDTransDeleted,
    vendorTransactions: state.reducer.vendorTransactions,
    buyerTransactions: state.reducer.buyerTransactions,
    contacts: state.reducer.contacts,
    buyerAgents: state.reducer.buyerAgents,
  };
};

export default connect(
  mapStateToProps,
  {
    getAllTransactionsAction,
    deleteTransactionDataAction,
    getVendorTransactionsAction,
    getBuyerTransactionsAction,
    getSubscriptionCounterAction,
    getContactsActions,
    buyerAgentsAction,
  }
)(TransactionList);
